import axiosApiInstance from "../../interceptors/axiosApiInstance";
import { BASE_URL } from "../config";

const triggerService = {
    createProfile: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/trigger/profile`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getTriggerProfileByAutomId: async function (autom_id, type) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/trigger/profile?autom_id=${autom_id}&type=${type}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkIsRunningStatus: async function (autom_id, type) {
        try {
            const response = await axiosApiInstance.get(
                await BASE_URL + `/trigger/checkIsRunning?autom_id=${autom_id}&type=${type}`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    createRule: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/trigger/rule`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getRules: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/trigger/rules`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getUnassignedAutoms: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/trigger/unassigne/automs`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getRuleById: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/trigger/rule/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateRule: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/trigger/rule/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteRules: async function (ids) {
        try {
            const response = await axiosApiInstance.delete(await BASE_URL + `/trigger/rules`, {
                data: { ids }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    triggerStart: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/trigger/start`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    triggerStop: async function (data) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/trigger/stop`,
                data
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    triggerStopByMateId: async function (id) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/trigger/${id}/stop`
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
};
export default triggerService;
